import { FC } from "react";

/**
 * Right Arrow Icon Props Interface
 * @interface RightArrowProps
 */
interface RightArrowProps {
  color?: string;
}

const RightArrow: FC<RightArrowProps> = ({ color = "black" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1924 18.7071C13.8018 18.3166 13.8018 17.6834 14.1924 17.2929L18.4852 13L2.89942 13C2.34713 13 1.89942 12.5523 1.89942 12C1.89942 11.4477 2.34713 11 2.89942 11L18.4852 11L14.1924 6.7071C13.8018 6.31658 13.8018 5.68341 14.1924 5.29289C14.5829 4.90237 15.2161 4.90237 15.6066 5.2929L21.6065 11.2929C21.997 11.6834 21.997 12.3166 21.6065 12.7071L15.6066 18.7071C15.2161 19.0976 14.5829 19.0976 14.1924 18.7071Z"
        fill={color}
      />
    </svg>
  );
};

export default RightArrow;
